import FormWithControls from 'app/shared-components/FormWithControls'
import StatusHandler from 'app/shared-components/StatusHandler'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import LoggerRequest from 'app/requests/Logger.requests'

import useGetLoggerByLoggerNumber from '../hooks/useGetLoggerByLoggerNumber'

import loggerUpdateFields from './LoggerUpdate.fields'
import useStyles from './LoggerUpdate.style'

const LoggerUpdate = ({
    id: loggerNumber,
}: { id: string }) => {
    const {
        classes,
    } = useStyles()

    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetLoggerByLoggerNumber(loggerNumber)

    const fields = useFieldsWithClassName(loggerUpdateFields(data?.rentingCompany), classes)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <FormWithControls
                name={LoggerRequest.domainName}
                value={data}
                fields={fields}
                onSuccess={invalidate}
                classNames={{
                    gridWrapper: classes.gridWrapper,
                }}
                requestParams={LoggerRequest.update({
                    serialNumber: String(data?.id),
                })}
                exists
            />
        </StatusHandler>
    )
}

export default LoggerUpdate
